import scrollToSelector from '../util/scrollToSelector';

export default function hero() {
  const selector = '.b-hero';

  if ($(selector).length === 0) {
    return;
  }

  $(`${selector}__next-section-button`).on('click', function (event) {
    event.preventDefault();

    const nextBlock = $(this).parents(selector).next('.block');

    if (nextBlock.length > 0) {
      scrollToSelector(nextBlock);
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/blocks/hero.js